import { createReducer, Action, on } from '@ngrx/store';
import * as actions from './restoration.actions';

export interface State {
  loading: boolean;
  loaded: boolean;
  error: any;
}

export const initialState: State = {
  loaded: false,
  loading: false,
  error: null,
};

const restorationReducer = createReducer(
  initialState,
  on(actions.loadAllRestoration, state => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),
  on(actions.loadAllRestorationSuccess, state => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return restorationReducer(state, action);
}
